import React, { Component } from 'react'

class WholePxFixer extends Component {

  constructor(){
    super()

    this.state = {
      setSizeDelayTimeout: null
    }

    this.resize = this.resize.bind(this)
    this.setSize = this.setSize.bind(this)
  }


  componentDidMount(){
      window.addEventListener('resize',this.resize)
      this.resize();

      setTimeout(this.resize,10)
      setTimeout(this.resize,500)
  }

  componentWillUnmount(){
    window.removeEventListener('resize',this.resize)
  }

  resize(){
    if(this.props.watchList){
       this.props.watchList.split(',').map((item,i)=>{

          // collect elements
          let elements = document.querySelectorAll(item)

          for(let j=0; j < elements.length; j++ ){
              elements[j].style.width = '';
              elements[j].style.height = '';
              //console.log( elements[j].offsetWidth);

              //elements[j].style.width = Math.round(elements[j].offsetWidth)+'px';
              //elements[j].style.height = Math.round(elements[j].offsetHeight)+'px';
          }

       })
       clearTimeout(this.state.setSizeDelayTimeout)
       let setSizeDelayTimeout = setTimeout(this.setSize,100)
       this.setState({setSizeDelayTimeout})
     }
  }

  setSize(){
    //console.log("Delayed setSize");
    if(this.props.watchList){
       this.props.watchList.split(',').map((item,i)=>{

          // collect elements
          let elements = document.querySelectorAll(item)

          for(let j=0; j < elements.length; j++ ){

              //console.log( elements[j].offsetWidth);

              elements[j].style.width = Math.round(elements[j].offsetWidth)+'px';
              elements[j].style.height = Math.round(elements[j].offsetHeight)+'px';
          }

       })

     }
  }

  render() {
    return(
      null
    )
  }
}

export default WholePxFixer



// WEBPACK FOOTER //
// ./src/modules/misc/WholePxFixer.js